export function NPER(rate: number, payment: number, present: number, future: number = 0, type: number = 0) {
  // Return number of periods
  var num = payment * (1 + rate * type) - future * rate;
  var den = (present * rate + payment * (1 + rate * type));
  return Math.log(num / den) / Math.log(1 + rate);
}